module.exports = __webpack_public_path__ + "media/bootstrap-icons/brush-b911f3ec.svg";